

function NumberToMoney(n) {
   
    if (n) {
        n = parseFloat(n)
        n = n.toFixed(2)
    } else {
        n = "0.00"
    }
     
    return n
}
export default NumberToMoney